module.exports = " <main class=\"m-0 p-0\">\n  <app-navbar></app-navbar>  \n  <app-main></app-main>\n </main>\n\n"